__webpack_require__.p = "https://frontend-platform-package-accounts.ui.moostaging.com/";